import router from './index'
import NProgress from 'nprogress'

// import {
//   LoginStatusEnum,
//   UserModule,
// } from '@/store/modules/user'
// import { getLoginStatus } from '@/utils/auth'
// import { Message as ElMessage, MessageBox } from 'element-ui'
// import { redirectToLogin } from '@/utils'
import { AuthStatusEnum, getAuthStatus } from '@/utils/get-auth-status'
import { removeToken } from '@/utils/cookies'
import { checkLoginApi } from '@/api/user'


router.beforeEach(async (to, from, next) => {
  const authStatus = await getAuthStatus(to.query)
  // 用于区分刷新与关闭后重新打开
  if (authStatus === AuthStatusEnum.Invalid) {
    removeToken()
  }
  // 鉴权接口
  try {
    await checkLoginApi()
  } catch (error) {
    error
  }
  next()
})

// 参考流程图: https://www.processon.com/view/link/6115d8e1e0b34d0b1a54329d
// TODO: 待刘云完成接口对接后删除 false &&
// false && router.beforeEach(async (to, from, next) => {
//   NProgress.start()
//   const loginStatus = await getLoginStatus()
//   if (loginStatus === LoginStatusEnum.Login) {
//     if (to.name === 'Login') {
//       next({ path: '/' })
//     } else {
//       const currentRole = UserModule.userInfo?.role ?? '' // 当前用户角色
//       const hasPermission = Array.isArray(to.meta?.roles) && to.meta?.roles.includes(currentRole)
//       if (to.meta?.inWhiteList || hasPermission) {
//         next()
//       } else{
//         next({ name: '404' }) // 跳到404页面
//       }
//     }
//   } else if (loginStatus === LoginStatusEnum.OtherUserHasLoginFromOtherTab) {
//     if (to.meta?.inWhiteList) {
//       next()
//     } else {
//       window.location.reload()
//     }
//   } else {
//     // 状态是下面中的一种
//     // LoginStatusEnum.TokenInvalid
//     // LoginStatusEnum.NeverLogin
//     // LoginStatusEnum.LogoutFromOtherTab
//     if (to.meta?.inWhiteList) {
//       next()
//     } else {
//       if (loginStatus === LoginStatusEnum.TokenInvalid || loginStatus === LoginStatusEnum.LogoutFromOtherTab) {
//         ElMessage.info('登陆已失效，需要重新登录')
//       }
//       redirectToLogin()
//     }
//   }
// })

router.afterEach((to) => {
  // set page title
  document.title = (to.meta?.title ? `${to.meta.title}` : '')
  NProgress.done()
})
